import {AsyncPage} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {
  changeEnrollmentFileUploadFilters,
  changeSort,
  getEmployerProfileUploadDetails,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import {EmployerProfileDetails} from 'Enrollment/models/EmployerProfileDetails';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {
  withDateFilterProperties,
  withInequalityFilterProperties,
  withStringFilterProperties,
} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {toFormattedDateTime} from 'Shared/utilities/DateFormatter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import * as O from 'fp-ts/lib/Option';

type EmployerProfileProps = {
  employerProfileData: AsyncPage<Page<EmployerProfileDetails>>;
};

const UploadedEmployerProfileTable = (props: EmployerProfileProps) => {
  const dispatch = useDispatch();
  const {employerProfileUploadFilters, sort} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);

  const changeFilter = withValueChangedHook(employerProfileUploadFilters, changeEnrollmentFileUploadFilters, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: employerProfileUploadFilters,
  };

  return (
    <PagedView
      pagedViewKey="uploadedEmployerProfileTable"
      data={props.employerProfileData}
      sort={O.toUndefined(sort)}
      onChangeSort={sort => dispatch(changeSort(sort))}
      loadMore={page => dispatch(getEmployerProfileUploadDetails(page, employerProfileUploadFilters))}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="File Name"
            default
            sortColumnKey="fileName"
            filterProperties={withStringFilterProperties(filterProperties, 'fileName')}
          >
            {employerProfiles => employerProfiles.fileName}
          </Column>
          <Column
            {...columnProps}
            title="File Type"
            default
            sortColumnKey="fileType"
            filterProperties={withStringFilterProperties(filterProperties, 'fileType')}
          >
            {employerProfiles => employerProfiles.fileType?.name}
          </Column>
          <Column
            {...columnProps}
            title="Uploaded Date"
            default
            sortColumnKey="fileUploadedDate"
            filterProperties={withDateFilterProperties(filterProperties, 'fileUploadedDate')}
          >
            {employerProfiles => toFormattedDateTime(employerProfiles.fileUploadedDate!)}
          </Column>
          <Column
            {...columnProps}
            title="Successful #"
            default
            sortColumnKey="successfulRecords"
            filterProperties={withInequalityFilterProperties(filterProperties, 'successfulRecords')}
          >
            {employerProfiles => employerProfiles.successfulRecords}
          </Column>
          <Column
            {...columnProps}
            title="Unsuccessful  #"
            default
            sortColumnKey="unsuccessfulRecords"
            filterProperties={withInequalityFilterProperties(filterProperties, 'unsuccessfulRecords')}
          >
            {employerProfiles => employerProfiles.unsuccessfulRecords}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default UploadedEmployerProfileTable;
